import { render, staticRenderFns } from "./lrAIChatBox.vue?vue&type=template&id=918ee2d0&"
import script from "./lrAIChatBox.vue?vue&type=script&lang=js&"
export * from "./lrAIChatBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports